export default __webpack_public_path__ + "static/media/32.3fe6fd2a.png";